import { GeoEventRegion } from 'features/geoEvents/geoEventRegion.types';

export const hasRegionsChanged = (
  prevRegions: GeoEventRegion[],
  newRegions: GeoEventRegion[],
): boolean => {
  return (
    prevRegions.length !== newRegions.length ||
    prevRegions.some(
      (prevRegion, index) => prevRegion.id !== newRegions[index].id,
    )
  );
};
